module.exports = __webpack_public_path__ + "static/nekoruri-af46c6f4a54dbb224df5b299a0dcc22f.jpg";